import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import AATexLogo from '../atoms/_atoms.atex-logo';
import AButton from '../atoms/_atoms.button';
import ACardInfoItem from '../atoms/_atoms.card-info-item';
import { PRODUCT_CONFIG } from '../../config/product.config';

export default function MProductCard({
	title,
	img,
	href,
	atex,
	product,
}) {
	const keys = Object.keys(PRODUCT_CONFIG.cardIcons).filter(key => product[key]).slice(0, 5);
	const atexIcons = atex.map(item => (
		<AATexLogo
			key={item.uuid}
			src={item.image.url}
			alt={item.name}
			className="small"
		/>
	));

	return (
		<Link to={href} href={href}>
			<article className="m-product-card">
				<figure>
					<img src={img} alt={title} />

				</figure>
				<div className="card-body">
					<div className="product--atex-item">
						{atexIcons}
					</div>
					<h3 className="card-title">{title}</h3>
					<ul className="card-list">
						{keys.reduce((prev, key) => {
							if (!PRODUCT_CONFIG.cardIcons[key]) {
								return prev;
							}

							return [...prev, (
								<li key={key}>
									<ACardInfoItem
										{...PRODUCT_CONFIG.cardIcons[key]}
										value={product[key]}
									/>
								</li>)];
						}, [])}
					</ul>
					<AButton
						value="PRODUCT_INFO_LABEL.BUTTON_SEE_PRODUCT"
						className="card-button"
					/>
				</div>
			</article>
		</Link>
	);
}

MProductCard.propTypes = {
	title: PropTypes.string.isRequired,
	img: PropTypes.string.isRequired,
	href: PropTypes.string.isRequired,
	atex: PropTypes.array,
	product: PropTypes.any,
};

MProductCard.defaultProps = {
	atex: [],
	product: PropTypes.any,
};



// WEBPACK FOOTER //
// ./src/components/molecules/_molecules.product-card.js